module.exports = __webpack_public_path__ + "img/10_bg.6ecceceb.png";